import Button from "../buttons/button";
import TextArea from "../Input/TextArea";
import TransParentButton from "../TransparentButton.js/TransParentButton";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  heading,
  subheading,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  isNote = false,
  noteValue = '',
  noteChange = null,
  noteError = ""
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/10 backdrop-blur-sm">
      <div className="bg-white p-6 rounded-[19px] shadow-lg text-center lg:w-[400px] w-11/12 mx-auto">
        <div className="flex items-center justify-center mb-4">
          <img src="/warning.png" alt="" className="w-20 h-20" />
        </div>
        <p className="text-[17px] font-[600] text-black mb-2">{heading}</p>
        {subheading && (
          <p className="text-[14px] text-gray-600 mb-4">{subheading}</p>
        )}
        {isNote &&
          <TextArea
            id="note"
            name="note"
            placeholder="Enter note"
            value={noteValue}
            onChange={noteChange}
            errorMessage={noteError}
            maxLength={500}
            autoFocus={true}
          />}
        <div className="flex justify-center gap-4">
          <TransParentButton
            onClick={onClose}>
            {cancelLabel}
          </TransParentButton>
          <Button
            onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;